import { gql } from "@apollo/client";

export const GET_RESUMEN_CONTRATO = gql`
  query getResumenContrato($idEvaluacion: Int!) {
    resumenContrato(idEvaluacion: $idEvaluacion) {
      idEvaluacion
      mesAnio
      fechaDesde
      fechaHasta
      conexionReal
      conexionTeorica
      conexionPorcentaje
      planCuidado
    }
  }
`;